module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm4-d4f9acfcea248a2f04889358673c55c1.jpg";